import Filter from "components/Icons/Filter"
import { MdOutlineClose } from "react-icons/md"

export default ({
  label,
  name,
  value,
  onChange,
  type = "text",
  decoration,
  inputClassName = "",
  decorationClassName = "",
  disabled,
  className,
  filterIcon,
  onClick,
  setOpenSearch = () => {},
  openSearch = false,
}) => {
  return (
    <>
      <div
        className={`flex flex-row-reverse w-full rounded-[44px] overflow-hidden border shadow-[0_4px_10px_rgba(0,0,0,0.03)] ${className}`}
      >
        {filterIcon ? (
          <div className="h-[40px] border-[color:#E2E2E2] border-2 mt-1 py-1 px-[9px] rounded-3xl flex items-center">
            <button onClick={onClick}>
              <Filter aria-hidden="true" color="#323232" />
            </button>
          </div>
        ) : null}
        <input
          id={name}
          name={name}
          value={value}
          type={type}
          placeholder={label}
          aria-label={label}
          onChange={onChange}
          className={`peer block w-full pl-3 pr-[60px] py-2 text-[#C9C9C9] focus:outline-none focus:ring-0 appearance-none bg-transparent ${
            disabled ? "bg-gray-200" : ""
          } ${inputClassName}`}
          disabled={disabled}
        />
        <div
          className={`flex items-center pl-3 py-3 text-[#C9C9C9] ${
            disabled ? "bg-gray-200" : ""
          } ${decorationClassName}`}
        >
          {decoration}
        </div>
      </div>
      {openSearch && (
        <button
          onClick={setOpenSearch}
          style={{
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            borderRadius: "0px 44px 44px 0px",
          }}
          className="absolute right-0 bg-[#ED4400] flex items-center justify-center w-[48px] py-[10px] border border-[#ED4400]"
        >
          <MdOutlineClose size={20} />
        </button>
      )}
    </>
  )
}
